import { asyncRouterMap, constantRouterMap } from '@/router/index'
import {
  hasIntegrationModuleRole,
  hasInnerIntegrationStatsReportAccess,
  hasSuperAdminRole
} from '@/utils/privilegedRoleAccess'

/**
 * 判断是否有权限注册该路由（后端 menus + 前端角色兜底）
 * @param {Array} menus
 * @param {object} route
 * @param {string[]} roles normalize 后的角色名
 * @param {object|null} integrationModuleScope
 */
function hasPermission(menus, route, roles, integrationModuleScope) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus)
    if (currMenu != null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title
      }
      if (currMenu.icon != null && currMenu.title !== '') {
        route.meta.icon = currMenu.icon
      }
      if (currMenu.hidden != null) {
        route.hidden = currMenu.hidden !== 0
      }
      /** 前端强制隐藏侧栏（不受后台菜单 visible 覆盖），用于临时下线某模块 */
      if (route.meta && route.meta.forceHideInSidebar) {
        route.hidden = true
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort
      }
      return true
    }
    route.sort = 0
    if (route.meta && route.meta.allowWithoutMenu === true) {
      return true
    }
    if (route.hidden !== undefined && route.hidden === true) {
      route.sort = -1
      return true
    }
    /** ⑥ 积分统计管理员等：仅有积分模块角色但后端未单独配「积分管理」父级菜单时仍注册（与 permission.js 路由守卫一致） */
    if (route.name === 'integration' && hasIntegrationModuleRole(roles)) {
      return true
    }
    /** 未在 ums 菜单中挂「积分统计报表」时，凭角色仍可注册（明细/按月为 hidden 子路由不受影响） */
    if (route.name === 'innerIntegrationStatsReport' && hasInnerIntegrationStatsReportAccess(roles, integrationModuleScope)) {
      return true
    }
    /** 发货信息：未挂 ums 菜单时，仅超级管理员注册路由（《管理后台-发货信息页开发文档》§4.1） */
    if (route.name === 'shipmentRecord' && hasSuperAdminRole(roles)) {
      return true
    }
    return false
  }
  return true
}

function filterAccessibleChildren(route, menus, roles, integrationModuleScope) {
  if (!route.children || route.children.length === 0) {
    return route
  }
  route.children = route.children.filter((child) => {
    if (!hasPermission(menus, child, roles, integrationModuleScope)) {
      return false
    }
    filterAccessibleChildren(child, menus, roles, integrationModuleScope)
    return true
  })
  return route
}

function isEmptyRouteGroup(route) {
  return !!(route.children && route.children.length === 0)
}

//根据路由名称获取菜单
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name===menu.name) {
      return menu;
    }
  }
  return null;
}

//对菜单进行排序
function sortChildrenRecursively(router) {
  if (router.children && router.children.length > 0) {
    router.children.sort(compare('sort'))
    router.children.forEach(sortChildrenRecursively)
  }
}

function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    sortChildrenRecursively(accessedRouters[i])
  }
  accessedRouters.sort(compare('sort'))
}

//降序比较函数
function compare(p){
  return function(m,n){
    let a = m[p];
    let b = n[p];
    return b - a;
  }
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit, rootGetters }, data) {
      return new Promise(resolve => {
        const { menus } = data
        const roles = rootGetters.roles || []
        const integrationModuleScope = rootGetters.integrationModuleScope
        const accessedRouters = asyncRouterMap.filter(v => {
          //admin帐号直接返回所有菜单
          // if(username==='admin') return true;
          if (hasPermission(menus, v, roles, integrationModuleScope)) {
            if (v.children && v.children.length > 0) {
              filterAccessibleChildren(v, menus, roles, integrationModuleScope)
              if (isEmptyRouteGroup(v)) {
                return false
              }
              return v
            } else {
              return v
            }
          }
          return false
        })
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    }
  }
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js